import React from "react";
import "./Services.css";
import Heart from "../../img/heartemoji.png";
import Glass from "../../img/glasses.png";
import Hubmle from "../../img/humble.png";
import Card from "../Card/Card";
import resume from "./ranjeet_prasad.pdf";
import { themeContext } from "../../Context";
import { useContext } from "react";

function Services() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode;
  return (
    <div className="services" id="Services">
      {/* left side */}
      <div className="skills">
        <span style={{color:darkMode?'white':''}}>My</span>
        <span>Skills</span>
        <span style={{color:darkMode?'white':''}}  >Passonate Software Engineer</span>

        <div
          className="blur s-blur1"
          style={{
            background: "#ABF1FF94",
          }}
        ></div>
         <a href={resume} download>
        <button className="button s-button">Download Cv</button>
      </a>
      </div>
      {/* right side  */}

      <div className="cards">
        {/* 1st card */}
        <div style={{ left: "35rem", top: "-2rem" }}>
          <Card
            emoji={Heart}
            Heading={"Development"}
            details={"React,NodeJs,Talwind"}

          />
        </div>

        {/* 2nd card  */}
        <div style={{ top: "-2rem", left: "10rem" }}>
          <Card
            emoji={Glass}
            Heading={"Non-technical"}
            details={"TeamWork,Leadership"}

          />
        </div>

        {/* 3rd card  */}
        <div style={{ top: "19rem", left: "10rem" }}>
          <Card
            emoji={Hubmle}
            Heading={"Database and Storage"}
            details={"MySQL,MongoDB"}
          />
        </div>
        {/* 4rd card  */}
        <div style={{ top: "19rem", left: "35rem" }}>
          <Card
            emoji={Hubmle}
            Heading={"Programming language"}
            details={"C++,STL,Python,Js"}
          />
        </div>

        <div
          className="blur s-blur2"
          style={{
            background: "var(--purple)",
          }}
        ></div>
      </div>
    </div>
  );
}

export default Services;
